<template>
<div class='episode-grid-div'>

  <div class='chart-hover-div'> 
    <p v-if="activeEp.title==null" class='chart-hover-instructions'>click cells for more info</p>
    <p v-else class='chart-hover-text' :style="{color: getCellColor( activeEp.rating )}">
      s{{ activeEp.se }}e{{ activeEp.ep }}, {{ activeEp.title }}, {{ activeEp.rating }} stars
    </p>
  </div>

  <!-- season labels -->
  <div class='episode-grid-col-headers'>
    <svg :height="cellHeight" :width="width" transform="translate(0, 0)">
      <g v-for="(season, i) in activeShowSeasons" :key="i">
        <text 
          :transform="'translate(' + (season*cellWidth-(cellWidth/2)) + ',' + (cellHeight/2) + ')'"
          fill="white"
          text-anchor="middle"
          alignment-baseline="central"
          >s{{ season }}
        </text>
      </g>
    </svg>
  </div>

  <!-- grid of episodes -->
  <div class='episode-grid'>
    <svg :height="numRows*cellHeight" :width="width">
      <g
        v-for="(episode, i) in showData"
        :key="i"
        >
        <!-- <a :href="'https://www.imdb.com/title/' + episode['link']"> -->
          <rect
            class='episode-cell'
            id='episode-cell'

            :height="cellHeight"
            :width="cellWidth"
            :transform="'translate(' + (episode['se']-1)*cellWidth + ',' + (episode['ep']-1)*cellHeight + ')'"

            :fill="getCellColor( episode[config.x.name] )"
            :opacity="(episode.title === activeEpName) || (activeEpName === '') ? 1 : .2"

            @click="activeEpName = episode.title === activeEpName ? '' : episode.title"

            cursor="pointer"
          />
        <!-- </a> -->
      </g>
    </svg>
  </div>


  <!-- gradient legend -->
  <div class='episode-grid-legend'>

    <svg :height="cellHeight" :width="width">
      <defs>
        <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop 
            v-for="(gradient, i) in colorGradient" 
            :key="i"
            :offset="i + '%'"
            :style="'stop-color:' + gradient + ';stop-opacity:1'"
            >
          </stop>
        </linearGradient>
      </defs>
      <!-- left label -->
      <g :transform="'translate(' + (width/3 - 10) + ',' + (cellHeight/2)+ ')'">
        <text text-anchor="end" alignment-baseline="central" fill="white">4 stars</text></g>
      <!-- bar -->
      <rect fill="url(#grad1)" :height="cellHeight" :width="width/3" :transform="'translate(' + width*1/3 + ', 0)'" />      
      <!-- right label -->
      <g :transform="'translate(' + (width*2/3 + 10) + ',' + (cellHeight/2)+ ')'">
        <text text-anchor="start" alignment-baseline="central" fill="white">10 stars</text></g>
    </svg>
  </div>

</div>
</template>


<script>


import filter from "lodash.filter";
import uniq from "lodash.uniq";
import map from "lodash.map";

import { scaleSequential } from 'd3-scale';
import { interpolateSpectral } from 'd3-scale-chromatic';

import { myMax } from "../js/helpers.js";

export default {
  props: {
    showData: Array,
    activeShowName: String,
    config: Object,
    resize: Date
  },
  data() {
    return {
      height: 0,
      width: 0,
      cellHeight: 20,
      activeShowSeasons: [],
      activeEpName: '',
      colorGradient: {}
    }
  },
  watch: {
    resize() {
      this.getHeightWidth();
    },
    activeShowName() {
      this.updateActiveShowSeasons();
    },
    showData() {
      this.updateActiveShowSeasons();
    }
  },
  mounted() {
    this.getHeightWidth();
    this.updateActiveShowSeasons();
    this.setColorGradient();
  },
  computed: {
    activeEp() {
      const ep = filter(this.showData, ['title', this.activeEpName]);
      return ep.length > 0 ? ep[0] : ''
    },
    cellWidth() {
      return this.width / this.numCols;
    },
    numRows() {
      return myMax(this.showData, 'ep') 
    },
    numCols() {
      return myMax(this.showData, 'se')
    }
  },
  methods: {
    setColorGradient() {
      let colors = {};
      const pcts = [0, 12.5, 25, 73.5, 50, 62.5, 75, 87.5, 100]
      for (let i=0; i<pcts.length; i++) {
        const pct = pcts[i];
        const val = this.config.x.min + pct/100 * (this.config.x.max - this.config.x.min);
        colors[pct] = this.getCellColor(val);
      }
      this.colorGradient = colors
    },
    updateActiveShowSeasons() {
      let seasons = uniq(map(this.showData, 'se'))
      seasons.sort(function (a, b) { 
        return a < b;
      })
      this.activeShowSeasons = seasons;
    },
    getHeightWidth() {
      const height = Object.prototype.hasOwnProperty.call(this.config.shape, 'height') ? this.config.shape.height : this.$el.clientHeight
      const width = Object.prototype.hasOwnProperty.call(this.config.shape, 'width') ? this.config.shape.width : this.$el.clientWidth
      this.height = height;
      this.width = width;
    },
    getCellColor(val) {
      let color = scaleSequential()
        .domain([this.config.x.min, this.config.x.max])
        .interpolator(interpolateSpectral)
      return color(val)
    }
  }
}
</script>


<style lang='scss' scoped> 
.episode-grid-title {
  padding-bottom: 1rem;
}

.episode-cell {
  stroke: $bg-darkest;
  stroke-width: 2px;
}

.episode-grid-legend {
  padding-top: 2rem;
}


</style>


